import { Outlet } from 'react-router-dom';
import AppLayoutShell from '@/core/components/layout/shell/AppLayoutShell';

export default function AppLayoutRoute() {
    return (
        <AppLayoutShell>
            <Outlet />
        </AppLayoutShell>
    );
}
